var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useTrends } from '../hooks/use-trends';
import { useTransition, animated } from '@react-spring/web';
import { useProfileTypes } from '../hooks/use-profile-types';
import { useObjectives } from '../hooks/use-objectives';
import { useExpertiseLevels } from '../hooks/use-expertise-levels';
import { keyBy, sortBy, compact } from 'lodash';
import { useEntityTypes } from '../hooks/use-entity-types';
import { OnboardingSelectionStep } from '../elements/onboarding-selection-step';
import { OnboardingLayout } from './onboarding-layout';
import { OnboardingHeader } from './onboarding-header';
import { useLang } from '../hooks/use-lang';
import { OnboardingButton } from './onboarding-button';
import { gql, useMutation } from '@apollo/client';
import { ContentNode } from '../entities/content-node';
import { GridLoader } from './grid-loader';
import { useLink } from '../hooks/use-link';
import { useSite } from '../hooks/use-site';
import { UpdatePasswordFormLayout } from './update-password-form-layout';
var cls = classNames('onboarding-steps');
export var OnboardingStepsDefaultProps = {
  verify: ''
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TransitionContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n    height: 100%; \n    max-width: 700px;\n    margin: 0 ", ";\n  "], ["\n    position: relative;\n    width: 100%;\n    height: 100%; \n    max-width: 700px;\n    margin: 0 ", ";\n  "])), theme.UNIT(6))
});
var OnboardingStepStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: ", ";\n  "])), theme.UNIT(9))
});
var ContinueStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ChangePasswordMessageStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    text-align: center;\n  "], ["\n    text-align: center;\n  "])))
});
var LoaderStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    min-height: 100px;\n  "], ["\n    min-height: 100px;\n  "])))
});
var LoginStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'OnboardingSteps',
  Container: styled(OnboardingLayout)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled(OnboardingHeader)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  OnboardingStep: styled(OnboardingSelectionStep)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), OnboardingStepStyles),
  TransitionContainer: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TransitionContainerStyles),
  Body: styled(animated.div)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  ContinueButton: styled(OnboardingButton)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ContinueStyles),
  Loader: styled(GridLoader)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  ChangePasswordMessage: styled(ContentNode)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ChangePasswordMessageStyles),
  Login: styled(UpdatePasswordFormLayout)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), LoginStyles)
};
export var OnboardingSteps = function (props) {
  var _a;
  var componentProps = useComponentProps(My.NAME, OnboardingStepsDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    verify = componentProps.verify;
  var site = useSite();
  var destination = ((_a = site === null || site === void 0 ? void 0 : site.explorerPage) === null || _a === void 0 ? void 0 : _a.path) || '/app/profile';
  var navigate = useLink().navigate;
  var t = useLang();
  var trends = useTrends();
  var hasTrends = !!trends.length;
  var _b = __read(useMutation(gql(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    mutation OnboardUser($id: String!, $input: OnboardUserInput!) {\n      onboardUser(id: $id, input: $input)\n    }\n  "], ["\n    mutation OnboardUser($id: String!, $input: OnboardUserInput!) {\n      onboardUser(id: $id, input: $input)\n    }\n  "])))), 2),
    onboardUser = _b[0],
    _c = _b[1],
    loading = _c.loading,
    onboardUserData = _c.data;
  var entityTypes = useEntityTypes();
  var entityTypesByInternalName = keyBy(entityTypes, 'internalName');
  var expertiseLevels = sortBy(useExpertiseLevels(), 'orderNumber').filter(function (level) {
    return level.slug === "industry-expert";
  });
  console.log('expertiseLevels', expertiseLevels);
  var _d = __read(React.useState(0), 2),
    movingToStep = _d[0],
    setMovingToStep = _d[1];
  var _e = __read(React.useState(0), 2),
    currentStep = _e[0],
    setCurrentStep = _e[1];
  var _f = __read(React.useState({
      profileType: [],
      trendExpertise: [],
      trend: [],
      objective: [],
      login: null,
      password: ''
    }), 2),
    onboardingState = _f[0],
    setOnboardingState = _f[1];
  // onboarding steps config. Determines what to render at each step
  var onboardingSteps = compact(__spreadArray(__spreadArray([hasTrends && !expertiseLevels.length &&
  // hacky but set the expertiseLevel condition to ensure ADSW isnt affected for the moment
  {
    title: "Which Scientific Platforms are you interested in?",
    entityKey: "trend",
    fetchHook: useTrends
  }, {
    title: "Which best describes you?",
    entityKey: "profileType",
    fetchHook: useProfileTypes
  }], __read(expertiseLevels.map(function (level) {
    var _a;
    return {
      title: "Are you <b>".concat(level.promptLabel || level.name, "</b> in any of these ").concat(((_a = entityTypesByInternalName['Trend']) === null || _a === void 0 ? void 0 : _a.pluralLabel) || 'Trends', "?"),
      entityKey: "trendExpertise",
      fetchHook: useTrends,
      expertiseLevel: level
    };
  })), false), [{
    title: "What are your priority objectives?",
    entityKey: "objective",
    fetchHook: useObjectives
  }, {
    title: "Last step. Create new password",
    entityKey: "login",
    fetchHook: function () {
      return [];
    }
  }], false));
  var currentConfig = onboardingSteps[currentStep];
  // pass selected entities of profileType and Objectives into OnboardingState
  var handleSelection = function (entityKey, selection) {
    // ignoring password and login keys as they're strings
    if (entityKey === 'password' || entityKey === 'login') {
      return;
    }
    setOnboardingState(function (prev) {
      var _a;
      return __assign(__assign({}, prev), (_a = {}, _a[entityKey] = (prev[entityKey] || []).some(function (item) {
        return item.id === selection.id;
      }) ? (prev[entityKey] || []).filter(function (item) {
        return item.id !== selection.id;
      }) : __spreadArray(__spreadArray([], __read(prev[entityKey] || []), false), [selection], false), _a));
    });
  };
  // pass selected trends on the expertiseLevel into OnboardingState against the trendExpertise key
  var handleTrendSelection = function (expertiseLevel, trend) {
    setOnboardingState(function (prev) {
      var existingEntry = prev.trendExpertise.find(function (entry) {
        return (entry === null || entry === void 0 ? void 0 : entry.levelOfExpertise.id) === (expertiseLevel === null || expertiseLevel === void 0 ? void 0 : expertiseLevel.id);
      });
      if (existingEntry) {
        return __assign(__assign({}, prev), {
          trendExpertise: prev === null || prev === void 0 ? void 0 : prev.trendExpertise.map(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.levelOfExpertise.id) === expertiseLevel.id ? __assign(__assign({}, entry), {
              trends: (entry === null || entry === void 0 ? void 0 : entry.trends.some(function (t) {
                return t.id === trend.id;
              })) ? entry === null || entry === void 0 ? void 0 : entry.trends.filter(function (t) {
                return t.id !== trend.id;
              }) : __spreadArray(__spreadArray([], __read(entry.trends), false), [trend], false)
            }) : entry;
          })
        });
      } else {
        return __assign(__assign({}, prev), {
          trendExpertise: __spreadArray(__spreadArray([], __read(prev === null || prev === void 0 ? void 0 : prev.trendExpertise), false), [{
            levelOfExpertise: expertiseLevel,
            trends: [trend]
          }], false)
        });
      }
    });
  };
  var goToNextStep = function () {
    return setMovingToStep(function (prev) {
      return Math.min(prev + 1, onboardingSteps.length - 1);
    });
  };
  var goToPreviousStep = function () {
    return setMovingToStep(function (prev) {
      return Math.max(prev - 1, 0);
    });
  };
  var transitions = useTransition(currentStep, {
    key: movingToStep,
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    },
    config: {
      duration: 300
    },
    exitBeforeEnter: true,
    // reset current step to movingToStep when animation is done
    onDestroyed: function () {
      return setCurrentStep(movingToStep);
    }
  });
  // set styles here to not cluster animated.div
  var animatedDivStyles = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  };
  // transformed the current state into the format required for mutation
  var transformOnboardingStateToInput = function (state) {
    return {
      types: state.profileType.map(function (profile) {
        return profile.id;
      }),
      trendExpertise: state.trendExpertise.map(function (entry) {
        return {
          levelOfExpertise: entry.levelOfExpertise.id,
          trends: entry.trends.map(function (trend) {
            return trend.id;
          })
        };
      }),
      trends: state.trend.map(function (trend) {
        return trend.id;
      }),
      objectives: state.objective.map(function (objective) {
        return objective.id;
      }),
      password: state.password || ''
    };
  };
  var onPasswordSubmit = function (newPassword) {
    setOnboardingState(function (prev) {
      return __assign(__assign({}, prev), {
        password: newPassword
      });
    });
  };
  React.useEffect(function () {
    var runOnboardUser = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var input;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              input = transformOnboardingStateToInput(onboardingState);
              // console.log('input', input);
              return [4 /*yield*/, onboardUser({
                variables: {
                  id: verify,
                  input: input
                }
              })];
            case 1:
              // console.log('input', input);
              _a.sent();
              return [2 /*return*/];
          }
        });
      });
    };
    if (onboardingState === null || onboardingState === void 0 ? void 0 : onboardingState.password) {
      runOnboardUser();
    }
  }, [onboardingState === null || onboardingState === void 0 ? void 0 : onboardingState.password]);
  return React.createElement(My.Container, {
    totalSteps: onboardingSteps.length,
    currentStep: currentStep,
    className: cls.name(className)
  }, React.createElement(My.TransitionContainer, null, transitions(function (style, stepIndex) {
    var _a;
    var isFinalStep = stepIndex === onboardingSteps.length - 1;
    var stepConfig = !isFinalStep && onboardingSteps[stepIndex];
    var items = (stepConfig === null || stepConfig === void 0 ? void 0 : stepConfig.fetchHook) ? stepConfig.fetchHook() : [];
    return React.createElement(My.Body, {
      style: __assign(__assign({}, style), animatedDivStyles)
    }, React.createElement(My.Header, {
      title: onboardingState.password ? 'All done!' : isFinalStep ? currentConfig.title : t(stepConfig === null || stepConfig === void 0 ? void 0 : stepConfig.title),
      pretitle: !!onboardingState.password ? '' : "Let\u2019s tailor your experience"
    }), isFinalStep ? onboardingState.password ? loading ? React.createElement(My.Loader, null) : React.createElement(React.Fragment, null, React.createElement(My.ChangePasswordMessage, {
      entity: {
        text: 'Thanks for completing the setup process. Click the button below to login with your new password and explore the community.'
      }
    }), React.createElement(My.ContinueButton, {
      onClick: function () {
        return navigate(destination);
      }
    }, t('Continue'))) : React.createElement(My.Login, {
      goToPreviousStep: goToPreviousStep,
      onSubmit: onPasswordSubmit
    }) : React.createElement(My.OnboardingStep, {
      title: stepConfig === null || stepConfig === void 0 ? void 0 : stepConfig.title,
      items: items,
      selectedItems: (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.expertiseLevel) ? ((_a = onboardingState.trendExpertise.find(function (entry) {
        return entry.levelOfExpertise.id === currentConfig.expertiseLevel.id;
      })) === null || _a === void 0 ? void 0 : _a.trends) || [] :
      // need to specify the expected result and ignore password and login as they arent recognised on Entity[] obvs!!
      (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.entityKey) === 'profileType' || (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.entityKey) === 'objective' || (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.entityKey) === 'trend' ? onboardingState[currentConfig.entityKey] : [],
      onSelect: function (selection) {
        return (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.expertiseLevel) ? handleTrendSelection(currentConfig.expertiseLevel, selection) : handleSelection(currentConfig.entityKey, selection);
      },
      hasPreviousStep: stepIndex > 0,
      hasNextStep: stepIndex < onboardingSteps.length - 1,
      goToNextStep: goToNextStep,
      goToPreviousStep: goToPreviousStep
    }));
  })));
};
OnboardingSteps.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;